import { StringTMap } from '@@types/common';
import { AllLog } from '@@types/Log';

import { uiState } from '~/stores/UiState';
import { action, observable, toJS } from 'mobx';
import { clone } from 'ramda';

class ReplyLogStore {
  @observable
  replyLogMap: StringTMap<AllLog> = {};

  getByChannelId = (channelId: string) => {
    return this.replyLogMap[channelId];
  };

  @action
  setReplyLog = (log: AllLog) => {
    this.replyLogMap = uiState.pickAndSetLruChannelIds(log.channelId, clone(toJS(log)))(this.replyLogMap);
  };

  @action
  removeReplyLog = (channelId: string) => {
    delete this.replyLogMap[channelId];
  };
}

export default ReplyLogStore;

export const replyLogStore = new ReplyLogStore();
